import { ConversationalAgentProtocolEnum, SingleTurnChatProtocolEnum, VoiceAgentProtocolEnum } from '@api';

export const getSingleTurnChatInferencerTypeLabel = (protocol: SingleTurnChatProtocolEnum | null): string => {
  switch (protocol) {
    case SingleTurnChatProtocolEnum.customApi:
      return 'Custom API';
    case SingleTurnChatProtocolEnum.openAiAssistant:
      return 'OpenAI Assistant';
    case SingleTurnChatProtocolEnum.azureOpenAiAssistant:
      return 'Azure OpenAI Assistant';
    case SingleTurnChatProtocolEnum.poe:
      return 'POE';
    case SingleTurnChatProtocolEnum.spitch:
      return 'Spitch';
    case SingleTurnChatProtocolEnum.aino:
      return 'Aino';
    default:
      return '—';
  }
};

export const getCAInferencerTypeLabel = (protocol: ConversationalAgentProtocolEnum | null): string => {
  switch (protocol) {
    case ConversationalAgentProtocolEnum.openAiAssistant:
      return 'OpenAI Assistant';
    case ConversationalAgentProtocolEnum.celina:
      return 'Celina';
    default:
      return '—';
  }
};

export const getVAInferencerTypeLabel = (protocol: VoiceAgentProtocolEnum | null): string => {
  switch (protocol) {
    case VoiceAgentProtocolEnum.celina:
      return 'Celina';
    case VoiceAgentProtocolEnum.livekit:
      return 'LiveKit';
    default:
      return '—';
  }
};
